import type ViewFilter from 'owa-service/lib/contract/ViewFilter';
import {
    bundleIcon,
    AttachFilled,
    AttachRegular,
    CalendarFilled,
    CalendarRegular,
    FlagFilled,
    FlagRegular,
    MailFilled,
    MailRegular,
    MailUnreadFilled,
    MailUnreadRegular,
    MentionFilled,
    MentionRegular,
    SendFilled,
    SendRegular,
    ArrowCircleUpFilled,
    ArrowCircleUpRegular,
} from '@fluentui/react-icons';
import type { JSX } from 'react';

// Bundled icons render both the filled and regular variants so that the filled
// version can be revealed on hover via CSS (see MailListFilterMenu.scss)
const MailIcon = bundleIcon(MailFilled, MailRegular);
const MailUnreadIcon = bundleIcon(MailUnreadFilled, MailUnreadRegular);
const FlagIcon = bundleIcon(FlagFilled, FlagRegular);
const SendIcon = bundleIcon(SendFilled, SendRegular);
const AttachIcon = bundleIcon(AttachFilled, AttachRegular);
const MentionIcon = bundleIcon(MentionFilled, MentionRegular);
const CalendarIcon = bundleIcon(CalendarFilled, CalendarRegular);
const ArrowCircleUpIcon = bundleIcon(ArrowCircleUpFilled, ArrowCircleUpRegular);

export function getViewFilterIcon(filter: ViewFilter | null): JSX.Element {
    switch (filter) {
        case 'All':
            return <MailIcon />;
        case 'Unread':
            return <MailUnreadIcon />;
        case 'Flagged':
            return <FlagIcon />;
        case 'ToOrCcMe':
            return <SendIcon />;
        case 'HasAttachment':
            return <AttachIcon />;
        case 'HasFile':
            return <AttachIcon />;
        case 'Mentioned':
            return <MentionIcon />;
        case 'HasCalendarInvite':
            return <CalendarIcon />;
        case 'CopilotHighPriority':
            return <ArrowCircleUpIcon />;
        case 'TaskActive':
        case 'TaskOverdue':
        case 'TaskCompleted':
        case 'DeprecatedSuggestions':
        case 'DeprecatedSuggestionsRespond':
        case 'DeprecatedSuggestionsDelete':
        case 'DeprecatedNoClutter':
        case 'DeprecatedClutter':
        case 'SystemCategory':
        case 'UserCategory':
        case 'Pinned':
        case 'Focused':
        case 'Locked':
        case 'Hashtag':
        case 'Liked':
        default:
            /* eslint-disable-next-line react/jsx-no-useless-fragment -- (https://aka.ms/OWALintWiki)
             * Don't use react fragments if there are no children
             *	> Fragments should contain more than one child - otherwise, there’s no need for a Fragment at all. */
            return <></>;
    }
}
